var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 44 49" }, props),
    React.createElement("path", { d: "M36.77 20.07l-6.56 6.69 1.56 9.43a.8.8 0 0 1-.37.88 1 1 0 0 1-.56.19.91.91 0 0 1-.44-.13l-8-4.44-8 4.44a.73.73 0 0 1-.94-.06.94.94 0 0 1-.44-.88l1.57-9.43-6.5-6.69a.82.82 0 0 1-.25-.94.83.83 0 0 1 .75-.62l9-1.32 4-8.62a.77.77 0 0 1 .81-.5.78.78 0 0 1 .81.5l4.06 8.62 8.94 1.32a.83.83 0 0 1 .75.62.9.9 0 0 1-.19.94z", fill: "#fff" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/NavBar/icons/Upgrade.svg